import routes from '@/routes';
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Box,
	Container
} from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { usePlans } from '@/hooks/price';
import { SITE_NAME, TRIAL_DAYS } from '@/config';
import { formatPrice } from '@/utils';

export function FaqAccordions() {
	const { t } = useTranslation();
	const { cheapestPlan } = usePlans();

	const bestPrice = formatPrice({
		amount: cheapestPlan?.baseAmount,
		currency: cheapestPlan?.currency
	});

	const items = t('faq.items', {
		returnObjects: true,
		siteName: SITE_NAME,
		trialDays: TRIAL_DAYS,
		bestPrice
	});

	return (
		<Box component="section" pb={[4, 8]} pt={[1, 3.75]}>
			<Container
				maxWidth="false"
				sx={{
					maxWidth: '992px',
					pl: '21px',
					pr: '22px'
				}}
			>
				<Box>
					{items.map((item, index) => (
						<Accordion key={index} sx={{ margin: '0 0' }}>
							<AccordionSummary
								sx={{
									'.MuiAccordionSummary-content': {
										my: ['21px', '30px']
									}
								}}
							>
								{item.question}
							</AccordionSummary>
							<AccordionDetails
								color="text.secondary"
								sx={{
									pt: ['1px', '12px'],
									pb: ['22px', '31px'],
									whiteSpace: 'pre-line'
								}}
							>
								<Trans
									defaults={item.answer}
									components={{
										anchor: (
											<Link
												style={{ fontWeight: 'bold' }}
												to={routes.pricing}
											/>
										)
									}}
								/>
							</AccordionDetails>
						</Accordion>
					))}
				</Box>
			</Container>
		</Box>
	);
}
